var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@material-ui/core";
export var Flex = function (_a) {
    var direction = _a.direction, align = _a.align, justify = _a.justify, grow = _a.grow, column = _a.column, center = _a.center, children = _a.children, props = __rest(_a, ["direction", "align", "justify", "grow", "column", "center", "children"]);
    return (_jsx(Box, __assign({ display: props.display || "flex", flexDirection: !!column ? "column" : direction || "row", alignItems: !!center ? "center" : align || undefined, justifyContent: !!center ? "center" : justify || undefined, flexGrow: grow ? (grow === true ? "1" : grow) : undefined }, props, { children: children }), void 0));
};
